module.exports = __webpack_public_path__ + "static/media/overview@3x.ad0ce834.png";